<template>
  <component
    :is="lazyLoad ? 'div' : 'CCard'"
    v-if="lazyLoad || (creativeReviews && creativeReviews.length)"
  >
    <CCardHeader v-if="!lazyLoad">
      Creative Reviews
      <CIcon
        v-c-tooltip="'Displays a list of buyer reviewed creatives'"
        name="cil-check-circle"
        size="custom"
      />
    </CCardHeader>
    <component :is="lazyLoad ? 'div' : 'CCardBody'">
      <slot name="form" />
      <div
        v-if="isLoading"
        class="text-center p-5"
      >
        <CSpinner
          style="width:2rem;height:2rem;"
          color="info"
          grow
        />
      </div>
      <div v-else-if="creativeReviews && creativeReviews.length">
        <CDataTable
          data-cy="table-creative-reviews"
          small
          border
          sorter
          column-filter
          :sorter-value="{ column: 'name', asc: true }"
          :items="formattedCreativeReviews"
          :fields="fields"
          :items-per-page="10"
          :pagination="{align: 'center'}"
        >
          <template #id="{item}">
            <td>
              <router-link
                :to="{ name: 'CreativeDetails', params: { id: getSafe(() => item.id)} }"
                target="_blank"
              >
                {{ getSafe(() => item.id) }}
              </router-link>

              <a
                href
                class="ml-1"
                @click.prevent="
                  copyIdToClipboard(getSafe(() => item.id))
                "
              ><CIcon
                name="cil-copy"
              /></a>
            </td>
          </template>
        </CDataTable>
      </div>
      <div v-else>
        No creative reviews found.
      </div>
    </component>
  </component>
</template>

<script>
import CreativeApi from '@/api/creative.api'

export default {
  name: 'BuyerCreatives',

  props: {
    accountId: {
      type: String,
      default: ''
    },

    lazyLoad: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {    
      isLoading: false,
      creativeReviews: [],  
      fields: [
        { key: 'id', label: 'ID', sortable: true },  
        { key: 'status', label: 'Status', sortable: true },   
        { key: 'cmsId', label: 'ID', sortable: true },
        { key: 'trafficSourceName', label: 'Traffic Source', sortable: true },               
        { key: 'countryId', label: 'Country', sortable: true },               
        { key: 'languageId', label: 'Language', sortable: true },
        { key: 'marketCategory', label: 'Type', sortable: true },
        { key: 'categoryName', label: 'Category', sortable: true }
      ],
    }
  },  

  computed: { 
    formattedCreativeReviews() {
      return this.creativeReviews        
        .map(review => {
          return {
            ...review,
            id: this.getSafe(() => review.creative.id),
            status: review.status,
            categoryName: 'Health - Medicare',
            trafficSourceName: this.getSafe(() => review.creative.trafficSourceName),
            cmsId: this.getSafe(() => review.creative.cmsId),
            countryId: this.getSafe(() => review.creative.countryCode),
            languageId: this.getSafe(() => review.creative.languageCode),
            marketCategory: this.getSafe(() => review.creative.marketCategory),
          }
        })
    }, 
  },
  
  async created () {
    if (!this.lazyLoad) {
      await this.loadCreatives()
    }
  },

  methods: {   

    async loadCreatives() {
      try {
        this.isLoading = true
        const response = await CreativeApi.getBuyerCreatives(this.accountId)
        this.creativeReviews = response.data
      } catch (error) {
        //
      } finally {
        this.isLoading = false
      }
    }    
  },
}
</script>

<style>

</style>